module.exports = __webpack_public_path__ + "assets/img/survey.00586f95.svg";